import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
	BrandCreationData,
	BrandImportPreview,
	BrandImportPreviewData,
	Checkbox
} from '@models/brands.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SNModalService } from '@web-services/modal/snModal.service';
import { RejectImportModalComponent } from '@web-components/brands/modals/reject-import-modal/reject-import-modal';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { AccountServiceProvider } from '@services/user/account.service';
import { BrandsServiceProvider } from '@services/brands/brands.service';

@Component({
	selector: 'import-data-modal',
	template: require('./import-data-modal.html'),
	styles: [require('./import-data-modal.scss')]
})
export class ImportDataModalComponent implements OnInit, OnDestroy {
	@Input() newBrandData: BrandCreationData;

	checkboxes: Array<Checkbox> = [];
	importDataForm;
	brands: BrandImportPreview;
	btnDisable: boolean;
	selectedBrand: BrandImportPreviewData;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private activeModal: NgbActiveModal,
		private fb: FormBuilder,
		private snModalService: SNModalService,
		private accountService: AccountServiceProvider,
		private brandsDataService: BrandsDataServiceProvider,
		private brandsService: BrandsServiceProvider
	) {}

	ngOnInit(): void {
		this.loadImportData();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	closeModal(): void {
		const rejectImportModal = this.snModalService.openModal(
			RejectImportModalComponent,
			{
				windowClass: 'ng-bootstrap-modal modal-visible modal-import'
			}
		);
		rejectImportModal.componentInstance.newBrandData = this.newBrandData;
		rejectImportModal.result
			.then(res => {
				if (res) {
					this.activeModal.close(res);
				}
			})
			.catch();
	}

	chooseBrandToImport(ev): void {
		this.initModalPage(this.brands, ev.target.options.selectedIndex);
	}

	performImport(): void {
		this.btnDisable = true;
		this.prepareBrandDataToSave();
		this.accountService
			.saveBrand(this.newBrandData)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(res => {
				this.brandsDataService
					.updateBrands()
					.pipe(
						takeUntil(this.unsubscribe),
						finalize((): boolean => (this.btnDisable = false))
					)
					.subscribe(() => {
						this.activeModal.close(res);
					});
			});
	}

	controlGroup(option: Checkbox, ev) {
		this.selectDeselectGroup(option.controlName, ev.target.checked);
	}

	controlParent(controls, group: Checkbox): void {
		// TODO Investigate
		setTimeout((): void => {
			group.isChecked = controls.value.indexOf(false) === -1;
		}, 0);
	}

	private selectDeselectGroup(groupName: string, state: boolean): void {
		this.importDataForm.controls[groupName].controls.forEach(
			(control): void => {
				control.setValue(state);
			}
		);
	}

	private createFormGroup(checkboxes: Array<Checkbox>): FormGroup {
		const fbData = <FormGroup>{};
		checkboxes.forEach((e: Checkbox): void => {
			if (e.children.length) {
				const innerData = [];
				e.children.forEach((i: Checkbox): void => {
					innerData.push(this.fb.control(i.isChecked));
				});
				fbData[e.controlName] = this.fb.array(innerData);
			}
		});

		return this.fb.group(fbData);
	}

	private loadImportData(): void {
		this.brandsDataService
			.getBrandsImportData()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: BrandImportPreview): void =>
				this.initModalPage(data, 0)
			);
	}

	private initModalPage(data: BrandImportPreview, companyIndex: number): void {
		this.checkboxes = this.brandsService.mapImportActions(
			data.brandsDataToImport[companyIndex]
		);
		this.importDataForm = null;
		this.importDataForm = this.createFormGroup(this.checkboxes);
		this.brands = data;
		this.selectedBrand = data.brandsDataToImport[companyIndex];
	}

	private prepareBrandDataToSave(): void {
		const data = this.brandsService.createImportListToSave(
			this.importDataForm,
			this.checkboxes
		);

		this.newBrandData.toImportData = {
			sourceCompanyId: null,
			types: null
		};

		if (data && data.length) {
			this.newBrandData.toImportData.sourceCompanyId = this.selectedBrand.companyId;
			this.newBrandData.toImportData.types = data;
		} else {
			this.newBrandData.toImportData = null;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/brands/modals/import-data-modal/import-data-modal.ts